<script lang="ts">
	import { invalidateAll } from '$app/navigation';
	import GlobalMedia from '$lib/components/media/GlobalMedia.svelte';
	import { page } from '$app/stores';
	import Media from '$lib/components/media/Media.svelte';
	import LocationsSwitcherBar from './LocationsSwitcherBar.svelte';
	import { createEventDispatcher } from 'svelte';
	import Text from '$lib/components/Text.svelte';

	const dispatch = createEventDispatcher();

	let container: HTMLDivElement;
</script>

<div class="location-selector-wrapper">
	<div class="location-label">
		<Text key="ecom_shipping_to" />
	</div>
	<div bind:this={container} class="location-selector" on:click>
		<div class="current-location">
			{$page.data.location} ({$page.data.locationCurrency})
		</div>
		<div class="arrow">
			<GlobalMedia key="icon-caret-right" />
		</div>
	</div>
</div>

<style lang="scss">
	.location-selector-wrapper {
		display: flex;
		align-items: center;
		gap: v(content-padding-xs);
	}

	.location-label {
		@include font(text-xs);
		text-transform: none;
		margin-top: 0.25rem;
		white-space: nowrap;
		letter-spacing: 0.1px;
	}

	.location-selector {
		position: relative;
		background: color(grey_08);
		padding: 4px 8px;
		@include font(info-sm);
		display: flex;
		align-items: center;
		gap: 3px;
		border-radius: 4px;
		cursor: pointer;
		transition: all 0.3s ease;
		white-space: nowrap;

		&:hover {
			background: color(grey_06);
		}

		&.open {
			background: white;
			color: color(black);
		}

		.current-location {
			display: flex;
			align-items: center;
			cursor: pointer;
		}

		.flag {
			display: flex;
			align-items: center;
			width: 12px;
			height: 12px;
			margin-inline-start: 8px;
		}

		.arrow {
			width: 8px;
			height: 8px;
			display: flex;
			align-items: center;
		}

		.switcher-dropdown {
			position: absolute;
			top: 38px;
			inset-inline-start: 0%;
			width: 100%;
			transform: translate(0, -32px);
			max-width: 80vw;
			max-height: 200px;
			overflow-y: auto;

			padding: 8px;
			background: white;

			display: flex;
			flex-direction: column;
			opacity: 0;
			@include transition(all);
			pointer-events: none;

			&.open {
				opacity: 1;
				transform: translate(0, 0);
				pointer-events: auto;
			}
		}

		.switcher-option {
			width: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
			text-align: center;
			cursor: pointer;
			padding: 4px 0;
			border-radius: v(border-radius);
			@include transition(all);
			text-decoration: none;

			color: color(text);
			white-space: nowrap;

			.location {
				cursor: pointer;
			}

			&:hover {
				background: #fff;
			}
		}
	}
</style>
